<template>
  <a-card>
    <a-descriptions title="Status Form / Trạng thái" :column="2">
      <a-descriptions-item label="Created by / Người tạo phiếu">
        {{ workLeave.author && workLeave.author.fullname }}
      </a-descriptions-item>
      <a-descriptions-item label="Status / Tình trạng">
        <StatusWorkLeave :status="workLeave.status" />
      </a-descriptions-item>
      <a-descriptions-item label="Created at / Ngày tạo phiếu">
        {{ workLeave.createdAt | formatDateHour }}
      </a-descriptions-item>
      <a-descriptions-item label="Updated at / Cập nhập lần cuối">
        {{ workLeave.updatedAt | formatDateHour }}
      </a-descriptions-item>
    </a-descriptions>
  </a-card>
</template>
<script>
import StatusWorkLeave from "./statusWorkLeave";
export default {
  components: { StatusWorkLeave },
  props: {
    workLeave: {
      type: Object,
      required: true,
    },
  },
  data() {
    return { datas: [] };
  },
  methods: {},
};
</script>
<style lang="css" scoped></style>
